export const WORD_START_LETTER_REGEX = /\b\p{L}/gu;
export const FIRST_START_LETTER_REGEX = /\b\w/;

export const NAME_REGEX = /^[A-Za-z\s]*[A-Za-z][A-Za-z\s]*$/;

export const PHONE_NUMBER_REGEX = /^\+?[1-9]\d{7,14}$/;

export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]*$/;

export const ALPHABET_START_WORD_REGEX = /^[A-Za-z].*/;
